import PropTypes from 'prop-types'
import React from 'react'
import { Head, Footer, FooterNew, Sidebar, Header } from '../../layout'
import { ErrorNotification } from '../../../ui/ErrorNotification'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import StpdBannerComponent from 'stpd-ad-component'
import { getAuthError } from '../../users/Auth/selectors'
import { setAuthError } from '../../users/Auth/actions'
import { getAppLoading, getIsMobileDevice } from '../../common/selectors'
import { setIsMobileDevice } from '../../common/actions'
import { getCurrentAd } from 'SRC/modules/ads/detail/selectors'
import { CookieConsent } from 'SRC/modules/common/components/CookieConsent'
import TopLoader from 'react-top-loader'
import config from 'SRC/config/config.json'
import { SideBanners } from '../SideBanners'


const Layout = ({
  setAuthError,
  children,
  title,
  error,
  ad,
  isLoading,
  isMobileDevice,
  isUserSearch,
  pageUrlItems,
  setIsMobileDevice
}) => {
  const router = useRouter()
  React.useEffect(() => { window.addEventListener('resize', windowSizeChanged) }, [])


  console.log('LAYOUT router.pathname', router.pathname)

  const windowSizeChanged = () => {
    const width = window.innerWidth

    console.log('windowSizeChanged', width)

    if (isMobileDevice && width > 1000) setIsMobileDevice(false)
    if (!isMobileDevice && width <= 1000) setIsMobileDevice(true)
  }

  const hideError = () => setAuthError('')

  return (
    <React.Fragment>
      <div className='container'>
        <Head
          title={title}
          ad={ad}
          pageUrlItems={pageUrlItems}
          isUserSearch={isUserSearch}
        />

        <Header />
        <main className={['/vehicleParts', '/vehiclePartsSearch'].includes(router?.pathname) && isMobileDevice ? 'vehicle-parts-page' : ''}>
          {children}
          {![
            '/vehiclePart',
            '/vehicleParts',
            '/vehiclePartsSearch',
            '/vehiclePartOrder',
            '/vehiclePartOrderFinancing',
            '/vehiclePartOrderPayment',
            '/vehiclePartOrderResult',
            '/formZakaziTehnickiPregled',
            '/formZakaziTehnickiPregledResult',
            '/formProvjeriCijenuRegistracije',
            '/formProvjeriCijenuRegistracijeResult',
          ].includes(router?.pathname) ? <Sidebar /> : null}
        </main>
        <FooterNew />

        <CookieConsent />
        <TopLoader show={isLoading} className='top-loader' />
        <ErrorNotification hideNotification={hideError} error={error} />

        {!isMobileDevice && config.banners.background ? <SideBanners /> : null}
      </div>

      {!isMobileDevice ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: 1000, height: 250 }}>
            <StpdBannerComponent
              refreshOnUrlChange={true}
              adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.bottom.adUnit}`}
              size={config.banners.bottom.sizes}
              divId={config.banners.bottom.slotId}
            />
          </div>
        </div>
      ) : null}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    error: getAuthError(state),
    isLoading: getAppLoading(state),
    ad: getCurrentAd(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

Layout.propTypes = {
  ad: PropTypes.object.isRequired,
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  error: PropTypes.string,
  pageUrlItems: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  isUserSearch: PropTypes.bool,
  setAuthError: PropTypes.func.isRequired,
  setIsMobileDevice: PropTypes.func.isRequired,
}

Layout.defaultProps = {
  title: 'AutoDiler',
  error: '',
  isLoading: false
}

export default connect(mapStateToProps, { setAuthError, setIsMobileDevice })(Layout)
